export default "__VITE_ASSET__4GnGEUxg__"